import React, { useState } from 'react';
import { ITags } from 'types';
import { useTranslation } from 'react-i18next';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import { OutsideFormInputNew } from 'components/Input/OutsideFormInputNew';
import Text from 'components/Text/Text';
import { LanguageBar } from './LanguageBar';
import classNames from 'classnames';

interface IProps {
	tags: ITags[];
	IDSelectedCustomerDefaultLanguage: Nullable<string>;
	IDsSelectedCustomerLanguages: string[];
	addTags: () => void;
	changeTags: (value: string, item: number, languageId: string) => void;
	deleteTag: (item: number) => void;
}

export const Tags: React.FC<IProps> = ({
	tags,
	IDSelectedCustomerDefaultLanguage,
	IDsSelectedCustomerLanguages,
	addTags,
	changeTags,
	deleteTag,
}) => {
	const { t } = useTranslation('form');
	const [selectedLanguage, setSelectedLanguage] = useState<Nullable<string>>(null);
	const isDefaultLanguageSelected = selectedLanguage === IDSelectedCustomerDefaultLanguage;

	return (
		<div className="flex flex-col gap-4">
			<LanguageBar
				tags={tags}
				selectedLanguage={selectedLanguage}
				IDSelectedCustomerDefaultLanguage={IDSelectedCustomerDefaultLanguage}
				IDsSelectedCustomerLanguages={IDsSelectedCustomerLanguages}
				setSelectedLanguage={setSelectedLanguage}
			/>
			{tags.map((el) => (
				<div
					key={el.languageId}
					className={classNames('-mx-4 flex flex-wrap gap-y-4', {
						hidden: el.languageId !== selectedLanguage || !el.tags.length,
					})}>
					{el.tags.map((tag, i) => (
						<div key={el.languageId + String(i)} className="w-1/3 px-4 flex items-start gap-2">
							<OutsideFormInputNew
								testId="Items"
								name={el.languageId + String(i)}
								label="tagLabel"
								placeholder="enterTagPlaceholder"
								translationOptions={{ counterValue: String(i + 1) }}
								errorMessage="enterTag"
								value={tag}
								onChange={(value) => changeTags(value, i, el.languageId)}
							/>
							{isDefaultLanguageSelected && (
								<NewButton
									className="mt-7.5"
									variant="shadow"
									color="red"
									size="small"
									icon={true}
									iconLeft={<Icon name={IconName.delete} size="lg" />}
									ariaLabel={t('deleteButton')}
									testId="DeleteTagBtn"
									onClick={() => deleteTag(i)}
								/>
							)}
						</div>
					))}
				</div>
			))}
			{isDefaultLanguageSelected && (
				<div>
					<NewButton
						size="small"
						iconLeft={<Icon name={IconName.plus} size="lg" />}
						disabled={(tags[0]?.tags.length ?? 0) > 17}
						testId="AddTagBtn"
						onClick={addTags}>
						<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
					</NewButton>
				</div>
			)}
		</div>
	);
};
